import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Filters from './index';


class FilterHoc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: ''
        }
    }
    getIsFilterActive(filterConfig) {
        let isActive = true;
        if (filterConfig && typeof filterConfig.active === 'boolean') {
            isActive = filterConfig.active;
        }
        return isActive;
    }
    getFilterConfigFromLayoutItem(layoutItem) {
        let config = null;
        if (layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.filterConfig) {
            config = layoutItem.itemProperties.filterConfig;
        }
        return config;
    }
    getFilterConfigFromWorkflowItem(workflowItem) {
        let config = null;
        const {containerIndex} = this.props;
        if (workflowItem && workflowItem.layoutProperties && workflowItem.layoutProperties.readAllFilterConfig && workflowItem.layoutProperties.readAllFilterConfig[containerIndex] && workflowItem.layoutProperties.readAllFilterConfig[containerIndex].filterConfig) {
            config = workflowItem.layoutProperties.readAllFilterConfig[containerIndex].filterConfig;
        }
        else if (workflowItem && workflowItem.layoutProperties && workflowItem.layoutProperties.readAllFilterConfig && workflowItem.layoutProperties.readAllFilterConfig.filterConfig) {
            config = workflowItem.layoutProperties.readAllFilterConfig.filterConfig;
        }
        return config;
    }
    handleChange(selectedOptions) {
        const { field, onFilterChange,filter, filterIndex } = this.props;
        this.setState({ selectedOptions });
    }
    render() {
        const filterConfig = this.getFilterConfigFromWorkflowItem(this.props.workflowItem);
        const filters = filterConfig && filterConfig.filters ? filterConfig.filters : [];
        const allFilters = (filterConfig && filterConfig.filterAll) ? true : false;

        return (
            <div>

                {
                    this.getIsFilterActive(filterConfig) ? <Filters filterFromTemplate={this.props.filterFromTemplate} filterConfig={filterConfig} allFilters={allFilters} filters={filters} fetchAfterFilter={this.props.fetchAfterFilter} {...this.props} /> : null
                }
            </div>
        );
    }
}

FilterHoc.defaultProps = {
    useLayoutItem: false
}

FilterHoc.propTypes = {
    useLayoutItem: PropTypes.bool,
};

export default FilterHoc;